import GetCoinList from "./GetCoinList";
import GetCoinWithdrawFeeList from "./GetCoinWithdrawFeeList";
import GetCwalletUserInfo from "./GetCwalletUserInfo";
import GetFaitList from "./GetFaitList";
import GetCoinInfo from "./GetCoinInfo";
import GetCoinPrice from "./GetCoinPirce";
import GetSwapCoinList from "./GetSwapCoinList";
import GetChainList from "./GetChainList";
// import { merchantStroe } from "@/stores";
import {
  GET_COIN_INFO_URL,
  GET_COIN_LIST_URL,
  GET_COIN_USDT_PRICE_URL,
  CWALLET_USERID,
  WITHDRAW_FEE,
  FAILT_LIST,
  SWAP_COIN_LIST,
  CHAIN_LIST,
} from "@/config";
import { useAuthContext } from "@/auth/useAuthContext";

export default function Index() {
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  let GET_COIN_INFO_URL_ = check ? GET_COIN_INFO_URL : "***";
  let GET_COIN_LIST_URL_ = check ? GET_COIN_LIST_URL : "***";
  let GET_COIN_USDT_PRICE_URL_ = check ? GET_COIN_USDT_PRICE_URL : "***";
  let CWALLET_USERID_ = check ? CWALLET_USERID : "***";
  let WITHDRAW_FEE_ = check ? WITHDRAW_FEE : "***";
  let FAILT_LIST_ = check ? FAILT_LIST : "***";
  let SWAP_COIN_LIST_ = check ? SWAP_COIN_LIST : "***";
  let CHAIN_LIST_ = check ? CHAIN_LIST : "***";

  return (
    <>
      <GetCoinList url={GET_COIN_LIST_URL_} />
      <GetCoinInfo url={GET_COIN_INFO_URL_} />
      <GetCoinPrice url={GET_COIN_USDT_PRICE_URL_} />
      <GetCwalletUserInfo url={CWALLET_USERID_} />
      <GetCoinWithdrawFeeList url={WITHDRAW_FEE_} />
      <GetFaitList url={FAILT_LIST_} />
      <GetSwapCoinList url={SWAP_COIN_LIST_} />
      <GetChainList url={CHAIN_LIST_} />
    </>
  );
}
